import { render, staticRenderFns } from "./CreditCardExpensesList.vue?vue&type=template&id=48b4134d&scoped=true"
import script from "./CreditCardExpensesList.vue?vue&type=script&lang=js"
export * from "./CreditCardExpensesList.vue?vue&type=script&lang=js"
import style0 from "./CreditCardExpensesList.vue?vue&type=style&index=0&id=48b4134d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4134d",
  null
  
)

export default component.exports